<template>
  <v-container>
    <div>
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}">
          </vc-date-picker>
        </v-col>

        <v-col cols="12" sm="2" justify="end">
          <v-btn color="primary" dark @click="getData">{{ $t('common.search') }}</v-btn>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="getData">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="date" :loading="loading"
                  class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event" :item-class="this.$statusAccountant">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="2">
              <span>Tổng số: <span class="summaryFont"> {{ totalManufactureRequest }} </span> </span>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectReadStatus" :items="readStatus" item-text="title" outlined :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="7">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress" @click="showRateDialog(item.sale)">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
              </span>
        </div>
      </template>


      <template v-slot:[`item.createdAt`]="{ item }">
        <span class="text-no-wrap">{{ item.createdAt | formateDate }}</span>
      </template>

      <template v-slot:[`item.infor`]="{ item }">
        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="showDetail(item)">
              info
            </v-icon>
          </template>
          <span>Thông tin chi tiết</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.designRequest.requestTitle`]="{ item }">
              <span class="contentTitle">
<!--                {{ item.designRequest.requestTitle + (item.designRequest.orderUnit ? (' - ' + item.designRequest.orderUnit.name) : '') }}-->
                {{ getManufactureTitle(item) }}
              </span>
      </template>

      <template v-slot:[`item.customer.fullname`]="{ item }">
              <span class="contentName">
                {{ item.customer.fullname }}
              </span>
      </template>

      <template v-slot:[`item.designer`]="{ item }">
        <div class="contentAddress" @click="showRateDialog(item.designer)" v-if="item.requestMethod !== 2">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.designer.avatar" :src="baseImage + item.designer.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.designer.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.designer.nickname }}
              </span>
        </div>
      </template>


      <!-- <template v-slot:item.sale="{ item }">
        <v-avatar size="30" class="mr-2">
          <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
          <img v-else src='@/assets/avatar_default.png'/>
        </v-avatar>

        {{ item.sale.fullname }}
      </template> -->


      <template v-slot:[`item.action`]="{ item }">
        <v-btn color="primary" @click="updateManufactureRequestStatus(item, 2)">
          {{ $t('common.approve') }}
        </v-btn>
      </template>

      <template v-slot:[`item.pending`]="{ item }">
        <v-btn color="primary" @click="updateManufactureRequestStatus(item, 3)">
          {{ $t('design_manager.forward_pending') }}
        </v-btn>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <manufacture-request-dialog v-model="dialogDetail" :editedItem="editedItem" :editable="true"
                                @closeDialog="closeDetail"
                                @update="updateManufactureItem" v-if="editedItem">
    </manufacture-request-dialog>

    <v-dialog v-model="rateDialog" max-width="400px">
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          Đánh giá nhân viên
        </v-card-title>

        <v-card-text>
          <div class="text-center mt-12">
            <v-rating v-model="rating"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments
                      large
                      hover
            ></v-rating>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="closeRate"> {{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" text @click="rateUser">
            {{ $t('common.rate') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
// import VNumericField from "@/components/VNumericField";
// import AddAddressDialog from "@/components/AddAddressDialog";
import ManufactureRequestDialog from "@/components/ManufactureRequestDialog";
import socketClient from "@/plugins/socketClient";

export default {

  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    rating: 5,

    dateRange: {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()},
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    overlay: false,
    isSearching: false,

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    selectUser: {},
    rateDialog: false,

    date: '',
    modal: false,

    selectedManufactureRequest: {},
    search: '',
    dialog: false,
    dialogDetail: false,
    designRequest: {},

    totalManufactureRequest: 0,

    selectReadStatus: {title: i18n.t('common.all'), value: -1},
    readStatus: [
      {title: i18n.t('common.unread'), value: 0},
      {title: i18n.t('common.read'), value: 1},
      {title: i18n.t('common.all'), value: -1}
    ],

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index',},
      {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
      {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
      {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
      // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
      {text: i18n.t('design_manager.date'), value: 'createdAt'},
      {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
      {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
      {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
      {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
      {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'infor'},
      {text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'action'},
      {text: '', align: 'center', sortable: false, value: 'pending'}
    ],
    desserts: [],
    originalDesserts: [],
    editedIndex: -1,
    editedItem: null,

    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 2) || i18n.t('validate.string_invalid')
    ],

    phoneRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
    ],
    emailRules: [
      v => !!v || i18n.t('validate.email_require'),
      v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
    ],
    addressRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 2) || i18n.t('validate.address_invalid'),
    ],
  }),

  components: {
    ManufactureRequestDialog: ManufactureRequestDialog
  },


  computed: {},

  watch: {
    selectReadStatus() {
      this.filterData();
    },
  },

  async created() {
    await this.getData();
    this.isSearching = true;

    const self = this;
    socketClient.getIO().on('CREATE_MANUFACTURE_REQUEST', () => {
      self.getData();
    });

    socketClient.getIO().on('EDIT_CREATED_MANUFACTURE_REQUEST', () => {
      self.getData();
    });

    socketClient.getIO().on('DESIGN_APPROVE_MANUFACTURE_REQUEST', () => {
      self.getData();
    });
  },

  methods: {
    initialize() {
    },

    getManufactureTitle(item) {
      return this.$getManufactureTitle(item);
    },

    filterData() {
      console.log(this.selectReadStatus.value);

      if (this.selectReadStatus.value !== -1) {
        this.desserts = [].concat(this.originalDesserts.filter(item => item.accountantReadStatus == this.selectReadStatus.value));
      } else {
        this.desserts = [].concat(this.originalDesserts);
      }

      this.totalManufactureRequest = this.desserts.length;
    },

    showDetail(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDetail = true;
    },

    updateManufactureItem(value) {
      Object.assign(this.desserts[this.editedIndex], value);
    },

    closeDetail(value) {
      this.dialogDetail = value
      this.editedItem = null;
    },

    async getData() {
      this.overlay = this.isSearching;
      try {
        // const response = await this.$http.get('/designRequest');
        const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");

        const response = await this.$http.get('/manufactureRequest/accountantStatus/1?' + "from=" + from + "&to=" + to);
        // const response = await this.$http.get('/manufactureRequest/status/2?' + "from=" + from + "&to=" + to)
        this.overlay = false;
        if (response.data && response.data.success) {
          console.log(response.data);

          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);
          this.desserts = contextArr;
          this.originalDesserts = contextArr;

          this.totalManufactureRequest = this.desserts.length;
          this.loading = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    updateManufactureRequestStatus(item, status) {
      let title = i18n.t('common.confirm_approve');

      const agree = confirm(title)
      if (agree) {
        this.updateRequestStatus(item, status);
      }
    },

    async updateRequestStatus(item, status) {
      this.editedIndex = this.desserts.indexOf(item);
      try {
        const requestBody = {
          accountantStatus: status
        }

        const response = await this.$http.put('/manufactureRequest/' + item._id + "/status", requestBody);

        if (response.data && response.data.success) {
          item.status = 1;
          Object.assign(this.desserts[this.editedIndex], this.item);

          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.getData();
          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    showRateDialog(user) {
      this.selectUser = user;
      this.rateDialog = true;
    },

    closeRate() {
      this.rateDialog = false
    },

    async rateUser() {
      try {
        const requestBody = {
          targetUser: this.selectUser._id,
          score: this.rating * 2,
          comment: ''
        }

        const response = await this.$http.post('/rateUser', requestBody);

        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.rate_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.closeRate();
          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },
  },
}
</script>